import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Button, IconButton, Popover } from '@material-ui/core';
import { ArrowBack, FilterList, Close } from '@material-ui/icons';
import { getPaymentReceiptHistory, getPaymentReportHistory } from '../../redux/actions/agentActions';
import DetailPaymentFilters from './components/DetailPaymentFilters';
import PaginationPaymentDetail from './components/PaginationPaymentDetail';
import TableHeader from './components/TableHeader';
import BarLoader from 'react-spinners/BarLoader';
import classNames from 'classnames';
import moment from 'moment';
import { formatNumber } from '../../libs/utils';
import { isMobile } from 'react-device-detect';

const formatDate = (date, format = 'DD/MM/YYYY') => {
  if (!date) return '—';
  return moment(date).format(format);
};

const styles = theme => ({
  container: {
    backgroundColor: '#FAFBFC',
    padding: '60px 4% 20px',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: isMobile ? 'wrap' : 'nowrap',
    marginBottom: '22px'
  },
  backButton: {
    marginRight: '16px',
    marginLeft: isMobile ? '4px' : '0px',
    color: '#2D6DF6'
  },
  title: {
    fontSize: '26px',
    color: '#000000 !important',
    fontWeight: 600,
    fontFamily: 'Sura Sans',
    padding: isMobile ? '0 16px' : '0px'
  },
  policyContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 3px 6px #00000029',
    padding: '18px 16px',
    marginBottom: '36px',
    borderRadius: '8px'
  },
  policyGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%'
  },
  policyGridItem: {
    paddingBottom: isMobile ? '10px' : '0px'
  },
  policyTitle: {
    fontSize: '22px',
    fontWeight: 600,
    color: '#00003F !important',
    paddingBottom: '11px',
    fontFamily: 'Sura Sans, system-ui',
    width: '100%'
  },
  policySubtitle: {
    fontSize: '12px',
    color: '#888B8D !important',
    marginBottom: '8px',
    fontFamily: 'Sura Sans, system-ui'
  },
  policyText: {
    fontSize: '26px',
    color: '#0133A0 !important',
    fontWeight: 600,
    fontFamily: 'Sura Sans, system-ui'
  },
  customerName: {
    fontSize: '26px',
    color: '#000000 !important',
    fontWeight: 400,
    fontFamily: 'Sura Sans, system-ui'
  },
  receiptsTitleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: isMobile ? 'wrap' : 'nowrap',
    marginBottom: '24px',
    gap: isMobile ? '11px' : '0px'
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '16px',
    paddingLeft: isMobile ? '16px' : '0px'
  },
  btnFilter: {
    backgroundColor: '#FFFFFF',
    color: '#0133A0',
    border: '1px solid #0133A0',
    borderRadius: '28px',
    padding: '6px 23px',
    fontFamily: 'Sura Sans, system-ui',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    transition: 'all 0.4s ease-in-out',
    '&:hover': {
      backgroundColor: '#0133A0',
      color: '#FFFFFF'
    }
  },
  btnDownload: {
    backgroundColor: '#0133A0',
    color: '#FFFFFF',
    borderRadius: '28px',
    padding: '6px 23px',
    fontFamily: 'Sura Sans, system-ui',
    fontSize: '14px',
    fontWeight: 400,
    textTransform: 'none',
    transition: 'all 0.4s ease-in-out',
    '&:hover': {
      backgroundColor: '#2D6DF6'
    }
  },
  tableContainer: {
    width: '100%',
    overflowX: isMobile ? 'scroll' : 'visible',
    backgroundColor: isMobile ? 'rgba(229, 233, 234, .65)' : 'transparent'
  },
  receiptsContainer: {
    backgroundColor: '#E5E9EA',
    padding: '6px 6px 0',
    borderRadius: '8px 8px 0 0',
    height: isMobile ? '60vh' : '70vh',
    overflowY: 'scroll',
    width: isMobile ? '840px' : 'auto'
  },
  receiptContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    padding: '10px',
    marginBottom: '11px'
  },
  receiptRow: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '120px 120px 120px 120px 100px 100px 100px' : '11% 14% 14% 22% 13% 13% 13%',
    padding: '16px',
    borderBottom: '1px solid rgba(112, 112, 112, .25)'
  },
  receiptCell: {
    fontSize: '14px',
    color: '#000000',
    fontFamily: 'Sura Sans, system-ui'
  },
  receiptAquaCell: {
    fontSize: '14px',
    color: '#00AEC7',
    fontFamily: 'Sura Sans, system-ui'
  },
  receiptNumber: {
    fontSize: '14px',
    color: '#0133A0 !important',
    fontFamily: 'Sura Sans, system-ui',
    fontWeight: 600
  },
  movementRow: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '120px 120px 120px 120px 100px 100px 100px' : '11% 14% 14% 22% 13% 13% 13%',
    backgroundColor: '#00AEC717',
    border: '1px solid #00AEC7',
    borderRadius: '10px',
    padding: '16px 19px',
    marginTop: '10px'
  },
  movementCell: {
    fontSize: '14px',
    color: '#000000 !important',
    fontFamily: 'Sura Sans, system-ui'
  },
  movementTitle: {
    fontSize: '12px',
    color: '#888B8D',
    marginBottom: '4px',
    fontFamily: 'Sura Sans, system-ui'
  },
  statusText: {
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans, system-ui'
  },
  statusError: {
    color: '#D12D35 !important'
  },
  statusSuccess: {
    color: '#067014 !important'
  },
  activeFiltersContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '10px',
    marginTop: '16px',
    marginBottom: '24px',
    alignItems: 'center'
  },
  activeFilter: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#E0EAFF',
    padding: '6px 12px',
    gap: '8px'
  },
  activeFilterText: {
    fontSize: '14px',
    color: '#0033A0 !important',
    fontFamily: 'Sura Sans, system-ui'
  },
  activeFilterClose: {
    fontSize: '16px',
    color: '#2D6DF6',
    cursor: 'pointer'
  },
  clearAllButton: {
    color: '#0033A0',
    fontSize: '14px',
    fontWeight: 600,
    fontFamily: 'Sura Sans, system-ui',
    textTransform: 'none',
    padding: 0,
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
});

const PaymentMovements = ({ classes, paymentToken, getPaymentReceiptHistory, getPaymentReportHistory, paymentHistory }) => {
  const { uuid } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [showFilters, setShowFilters] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filters, setFilters] = useState({
    receiptNumber: '',
    startDate: '',
    endDate: '',
    amount: ''
  });
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        setLoading(true);
        
        if (paymentHistory && paymentHistory[uuid]) {
          const response = paymentHistory[uuid];
          if (response && response.data) {
            const paymentData = {
              ...response.data,
              pagination: response.pagination
            };
            setPaymentData(paymentData);
            return;
          }
        }

        const response = await getPaymentReceiptHistory(paymentToken, uuid);
        
        if (response && response.type === 'error.list') {
          console.error('Error fetching payment data:', response.errors[0].message);
          return;
        }

        if (response && response.data) {
          const paymentData = {
            ...response.data,
            pagination: response.pagination
          };
          setPaymentData(paymentData);
        } else {
          console.error('Invalid response format:', response);
        }
      } catch (error) {
        console.error('Error fetching payment data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentData();
  }, [uuid, paymentToken, getPaymentReceiptHistory, paymentHistory]);

  const handleBackClick = () => {
    history.push('/cobranza/agente');
  };

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'filter-popover' : undefined;

  const handleDownloadClick = async () => {
    try {
      const queryParams = new URLSearchParams();
      
      if (filters.receiptNumber) queryParams.append('identifier', filters.receiptNumber);
      if (filters.startDate) queryParams.append('startAt', filters.startDate);
      if (filters.endDate) queryParams.append('endAt', filters.endDate);
      if (filters.amount) queryParams.append('amount', filters.amount);

      const response = await getPaymentReportHistory(paymentToken, uuid, queryParams.toString());
      
      if (response && response.data) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `reporte_movimientos_${uuid}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error('Error al descargar el reporte:', error);
    }
  };

  const handleFilterRemove = (filter) => {
    setActiveFilters(prev => prev.filter(f => f !== filter));
  };

  const handleClearAllFilters = () => {
    setFilters({
      receiptNumber: '',
      startDate: '',
      endDate: '',
      amount: ''
    });
    setActiveFilters([]);
    setPage(1);

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('limit', rowsPerPage);
    getPaymentReceiptHistory(paymentToken, uuid, queryParams.toString());
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const queryParams = new URLSearchParams();
    queryParams.append('page', newPage);
    queryParams.append('limit', rowsPerPage);
    
    if (filters.receiptNumber) queryParams.append('identifier', filters.receiptNumber);
    if (filters.startDate) queryParams.append('startAt', filters.startDate);
    if (filters.endDate) queryParams.append('endAt', filters.endDate);
    if (filters.amount) queryParams.append('amount', filters.amount);

    getPaymentReceiptHistory(paymentToken, uuid, queryParams.toString());
    window.scrollTo(0, 0);
  };

  const handleChangeRowsPerPage = event => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(1);

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('limit', newRowsPerPage);
    
    if (filters.receiptNumber) queryParams.append('identifier', filters.receiptNumber);
    if (filters.startDate) queryParams.append('startAt', filters.startDate);
    if (filters.endDate) queryParams.append('endAt', filters.endDate);
    if (filters.amount) queryParams.append('amount', filters.amount);

    getPaymentReceiptHistory(paymentToken, uuid, queryParams.toString());
  };

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    const newActiveFilters = [];
    if (newFilters.receiptNumber) {
      newActiveFilters.push(`Recibo: ${newFilters.receiptNumber}`);
    }
    if (newFilters.startDate || newFilters.endDate) {
      const startDate = newFilters.startDate ? moment(newFilters.startDate).format('DD/MM/YYYY') : '';
      const endDate = newFilters.endDate ? moment(newFilters.endDate).format('DD/MM/YYYY') : '';
      newActiveFilters.push(`Vigencia: ${startDate} - ${endDate}`);
    }
    if (newFilters.amount) {
      newActiveFilters.push(`Importe: ${newFilters.amount}`);
    }
    setActiveFilters(newActiveFilters);
    setPage(1);

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('limit', rowsPerPage);
    if (newFilters.receiptNumber) queryParams.append('identifier', newFilters.receiptNumber);
    if (newFilters.startDate) queryParams.append('startAt', newFilters.startDate);
    if (newFilters.endDate) queryParams.append('endAt', newFilters.endDate);
    if (newFilters.amount) queryParams.append('amount', newFilters.amount);

    getPaymentReceiptHistory(paymentToken, uuid, queryParams.toString());
  };

  const filterReceipts = (receipts) => {
    if (!receipts) return [];
    
    return receipts.filter(receipt => {
      if (filters.receiptNumber && !receipt.identifier.includes(filters.receiptNumber)) {
        return false;
      }

      if (filters.startDate && moment(receipt.issue_date).isBefore(filters.startDate)) {
        return false;
      }
      if (filters.endDate && moment(receipt.due_date).isAfter(filters.endDate)) {
        return false;
      }
      
      if (filters.amount && receipt.importMO !== parseFloat(filters.amount)) {
        return false;
      }

      return true;
    });
  };

  const handleSort = (column) => {
    if (column === 'paid_at') return;
    
    let newDirection = 'asc';
    if (sortColumn === column) {
      newDirection = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    
    setSortColumn(column);
    setSortDirection(newDirection);
    setPage(1);

    const queryParams = new URLSearchParams();
    queryParams.append('page', 1);
    queryParams.append('limit', rowsPerPage);
    queryParams.append('order_by', column);
    queryParams.append('order_dir', newDirection);
    
    if (filters.receiptNumber) queryParams.append('identifier', filters.receiptNumber);
    if (filters.startDate) queryParams.append('startAt', filters.startDate);
    if (filters.endDate) queryParams.append('endAt', filters.endDate);
    if (filters.amount) queryParams.append('amount', filters.amount);

    getPaymentReceiptHistory(paymentToken, uuid, queryParams.toString())
      .then(response => {
        if (response && response.data) {
          const paymentData = {
            ...response.data,
            pagination: response.pagination
          };
          setPaymentData(paymentData);
        }
      })
      .catch(error => {
        console.error('Error fetching sorted payment data:', error);
      });
  };

  if (loading) {
    return <BarLoader />;
  }

  if (!paymentData) {
    return (
      <div className={classes.container}>
        <Typography>No se encontraron datos del pago</Typography>
      </div>
    );
  }

  const statusMessages = {
    PAYMENT_SUCCESS: 'Pago',
    PAYMENT_ERROR: 'Intento de cobro - Rechazado',
    POLICY_CREATED_RECURRING_PAYMENT: 'Alta domiciliación',
    PAYMENT_PENDING: 'Pendiente de pago',
    POLICY_CANCELLED_RECURRING_PAYMENT: 'Baja domiciliación',
    RECURRING_PAYMENT_ERROR: 'Error al intentar cobrar el recibo mediante la domiciliación',
    POLICY_CHANGE_RECURRING_PAYMENT: 'Cambio'
  };

  const filteredReceipts = filterReceipts(paymentData && paymentData.receipts ? paymentData.receipts : []);
  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  const paginatedReceipts = filteredReceipts.slice(startIndex, endIndex);

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <IconButton className={classes.backButton} onClick={handleBackClick}>
          <ArrowBack />
        </IconButton>
        <Typography className={classes.title}>Detalle movimientos de cobro</Typography>
      </div>

      <div className={classes.policyContainer}>
        <Typography className={classes.policyTitle}>Detalle de póliza</Typography>
        <div className={classes.policyGrid}>
          <div className={classes.policyGridItem} style={{ paddingRight: isMobile ? '0px' : '40px' }}>
            <Typography className={classes.policySubtitle}>Oficina, Ramo, Póliza</Typography>
            <Typography className={classes.policyText}>
              {paymentData.office_id} - {paymentData.product_id} - {paymentData.policy_id}
            </Typography>
          </div>
          <div className={classes.policyGridItem}>
            <Typography className={classes.policySubtitle}>Nombre contratante</Typography>
            <Typography className={classes.customerName}>
              {paymentData.customer && paymentData.customer.name ? paymentData.customer.name : 'No disponible'}
            </Typography>
          </div>
        </div>
      </div>

      <div className={classes.receiptsTitleRow}>
        <Typography className={classes.title}>Detalle de recibos y movimientos</Typography>
        <div className={classes.buttonsContainer}>
          <Button
            className={classes.btnFilter}
            onClick={handleFilterClick}
          >
            Filtros
          </Button>
          <Button
            className={classes.btnDownload}
            onClick={handleDownloadClick}
          >
            Descargar histórico
          </Button>
        </div>
      </div>

      {activeFilters.length > 0 && (
        <div className={classes.activeFiltersContainer}>
          {activeFilters.map((filter, index) => (
            <div key={index} className={classes.activeFilter}>
              <Typography className={classes.activeFilterText}>{filter}</Typography>
              <Close
                className={classes.activeFilterClose}
                onClick={() => {
                  const updatedFilters = { ...filters };
                  if (filter.startsWith('Recibo:')) {
                    updatedFilters.receiptNumber = '';
                  } else if (filter.startsWith('Vigencia:')) {
                    updatedFilters.startDate = '';
                    updatedFilters.endDate = '';
                  } else if (filter.startsWith('Importe:')) {
                    updatedFilters.amount = '';
                  }
                  handleFilterChange(updatedFilters);
                }}
              />
            </div>
          ))}
          <Button
            className={classes.clearAllButton}
            onClick={handleClearAllFilters}
          >
            <Close style={{ fontSize: '16px', marginRight: '4px' }} />
            Limpiar todos
          </Button>
        </div>
      )}

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleFilterClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            borderRadius: '12px',
          }
        }}
      >
        <DetailPaymentFilters
          onFilterChange={handleFilterChange}
          onClearAll={handleClearAllFilters}
          onClose={handleFilterClose}
          uuid={uuid}
          token={paymentToken}
        />
      </Popover>
      <div className={classes.tableContainer}> 
        <TableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={handleSort}
        />

        <div className={classes.receiptsContainer}>
          {paginatedReceipts.map((receipt, index) => (
            <div key={index} className={classes.receiptContainer}>
              <div className={classes.receiptRow}>
                <div className={classes.receiptNumber}>{receipt.identifier}</div>
                <div className={classes.receiptCell}>
                  <span className={classes.movementTitle}>In.</span>
                  {formatDate(receipt.issue_date)}<br></br>
                  <span className={classes.movementTitle}>Fin</span>
                  {formatDate(receipt.due_date)}
                  </div>
                <div className={classes.receiptCell}>{formatDate(receipt.extension_date)}</div>
                <div className={classes.receiptAquaCell}>{formatDate(receipt.paid_at)}</div>
                <div className={classes.receiptCell}>{formatNumber(receipt.importMO, 2)}</div>
                <div className={classes.receiptCell}>{receipt.currency}</div>
                <div className={classes.receiptCell}>{formatNumber(receipt.importMXN, 2)}</div>
              </div>

              {receipt.events && receipt.events
                .sort((a, b) => b.order - a.order)
                .map((event, eventIndex) => (
                <div key={eventIndex} className={classes.movementRow}>
                  <div>
                    <Typography className={classes.movementTitle}>Movimiento</Typography>
                    <Typography className={classes.movementCell}>{event.order}</Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementTitle}>Fecha de movimiento</Typography>
                    <Typography className={classes.movementCell}>{formatDate(event.cdate, 'DD/MM/YYYY - HH:mm')}</Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementTitle}>Tipo de movimiento</Typography>
                    <Typography className={classNames(
                      classes.statusText,
                      (event.event_type === 'PAYMENT_ERROR' || event.event_type === 'RECURRING_PAYMENT_ERROR' || event.event_type === 'POLICY_CANCELLED_RECURRING_PAYMENT') 
                        ? classes.statusError 
                        : classes.statusSuccess
                    )}>
                      {statusMessages[event.event_type] || event.event_type}<br></br>
                      {event.num_intents >= 1 && `Intento de cobro - ${event.num_intents}`}
                    </Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementTitle}>Medio de cobro</Typography>
                    <Typography className={classes.movementCell}>
                      {event.isRecurringPayment && (
                        <Typography className={classes.movementCell}>
                          Domiciliado
                          <br></br>
                        </Typography>
                      )}
                      {event.card_info && event.card_info.last4 ? `**** **** **** ${event.card_info.last4}` : 'No disponible'}
                    </Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementCell}>{formatNumber(event.amount || '0', 2)}</Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementCell}>{event.currency || 'MXN'}</Typography>
                  </div>
                  <div>
                    <Typography className={classes.movementCell}>{formatNumber(event.amount || '0', 2)}</Typography>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <PaginationPaymentDetail
          filteredReceipts={filteredReceipts}
          page={page}
          rowsPerPage={rowsPerPage}
          paymentData={paymentData}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  paymentToken: state.agentReducer.paymentToken,
  paymentHistory: state.agentReducer.paymentHistory
});

const mapDispatchToProps = {
  getPaymentReceiptHistory,
  getPaymentReportHistory
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PaymentMovements)); 


// WEBPACK FOOTER //
// ./src/containers/paymentMovements/index.js